import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

export const useConfirmExit = (
  confirmExit: (confirmNavigation: () => void) => void,
  isUnsaved = false,
) => {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!isUnsaved) return;

    const originalPush = navigator.push;
    const originalReplace = navigator.replace;

    const handleNavigation = (
      method: (...args: Parameters<typeof originalPush>) => void,
    ) => {
      return (...args: Parameters<typeof originalPush>) => {
        const confirm = () => method(...args);
        confirmExit(confirm);
      };
    };

    navigator.push = handleNavigation(originalPush);
    navigator.replace = handleNavigation(originalReplace);

    return () => {
      navigator.push = originalPush;
      navigator.replace = originalReplace;
    };
  }, [navigator, confirmExit, isUnsaved]);
};
